module.exports = __webpack_public_path__ + "static/img/40001 (3).e7a8cdc.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/40000/40001 (3).webp
// module id = fwu/
// module chunks = 14